import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouses_min', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        stack: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouses_micro', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        get: (cntx, params) => {
            console.log(params)
            return new Promise((resolve, reject) => {
                axios.get('warehouses', {
                    params: {
                        warehouse_id: params.id,
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        listChildren: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouses', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        show: (cntx, { id }) => axios.get(`warehouses/${id}`)
            .then(response => response.data)
            .catch(error => {
                throw error
            }),
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('warehouses', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => {
            console.log(params)
            return new Promise((resolve, reject) => {
                axios.put(`warehouses/${params.id}`, params.data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`warehouses/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        levels: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('levels', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        locations: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('locations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        companies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('companies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        stackGrades: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('partition_grades', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        layouts: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('layouts', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        societies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('source_societies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        groups: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('groups', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
